module.exports = __webpack_public_path__ + "img/lt02.ceffed9f.png";